import { IBroker } from "@rentiohq/shared-frontend/dist/types/broker.types";

export interface IExtraData {
  broker: IBroker;
}

export enum EField {
  /**
   * The office's income table, held whole. Three rows, and the lower bound of
   * each is where the row above it ends, so it is shown rather than typed: two
   * brokers filling in bounds by hand is two brokers leaving a gap.
   */
  IncomeRanges = "incomeRanges",
}
